import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import axios from 'axios';
import { useI18n } from 'vue-i18n';

// Answering a party invite, shared by the classic PartyInviteModal and the v5 one.
export default function usePartyInvite(props) {
  const { t } = useI18n();
  const store = useStore();
  const responding = ref(false);
  const error = ref(null);

  const inviterName = computed(
    () => props.invite.inviter?.username || props.invite.party?.owner?.username || t('play.matchmaking.someone'),
  );

  function respond(intent) {
    responding.value = true;
    error.value = null;
    axios
      // PUT, not PATCH: rack-cors only allows GET/POST/PUT/DELETE/OPTIONS, so a
      // cross-origin PATCH preflight is refused and never reaches the API.
      .put(`/matchmaking/party_invites/${props.invite.id}`, { intent })
      .then(() => {
        store.commit('removeMatchmakingPartyInvite', props.invite.id);
        if (intent === 'accept') {
          // Joining replaces the current party — refresh it
          return axios.get('/matchmaking/parties').then(({ data }) => {
            store.commit('setMatchmakingParty', data.current || data.owned);
          });
        }
        return undefined;
      })
      .catch((err) => {
        error.value = err.response?.data?.errors?.join(', ') || err.response?.data?.error || t('play.matchmaking.something_went_wrong');
      })
      .finally(() => {
        responding.value = false;
      });
  }

  return {
    responding, error, inviterName, respond,
  };
}
